import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { funnelActivesApi, funnelApi } from '#app/api';
import { prefetchManagerValuations } from '#app/components/funnel/aton/useManagerValuations';
import { useAppUserContext } from '#app/contexts/UserContext';

function resolveAtonValuation(user: ReturnType<typeof useAppUserContext>): number {
    const raw = user.config.getConfByKey('ATON_SHOW_VALUATION');
    const parsed = parseInt(String(raw), 10);
    return Number.isNaN(parsed) ? 0 : parsed;
}

/**
 * Только прогрев RTK-кэша в фоне. Redux funnelData и расчёты — на странице воронки, как раньше.
 */
export function useFunnelBackgroundPreload(): void {
    const dispatch = useDispatch<any>();
    const user = useAppUserContext();
    const managerId = useSelector(
        (state: { auth?: { data?: { id?: number } } }) => state.auth?.data?.id
    );
    const atonValuation = resolveAtonValuation(user);

    useEffect(() => {
        if (!managerId) {
            return;
        }

        void dispatch(
            funnelApi.endpoints.getFunnelStatisticsDataset.initiate(
                {
                    withFinanceGroup: true,
                    domainUrl: process.env.REACT_APP_API_WHITESWAN_URL ?? null,
                },
                { subscribe: false }
            )
        );

        if (!Number.isNaN(atonValuation)) {
            void dispatch(
                funnelActivesApi.endpoints.getFunnelActivesClientsPack.initiate(
                    { managerId },
                    { subscribe: false }
                )
            );
            void dispatch(
                funnelActivesApi.endpoints.getFunnelActivesInvestGrid.initiate(
                    { managerId, atonValuation },
                    { subscribe: false }
                )
            );
            void dispatch(
                funnelActivesApi.endpoints.getFunnelActivesRatingsServiceItems.initiate(
                    undefined,
                    { subscribe: false }
                )
            );
        }

        prefetchManagerValuations(dispatch, managerId);
    }, [atonValuation, dispatch, managerId]);
}
